module.exports = __webpack_public_path__ + "img/xiaozi.674f1e73.webp";